import { storageService } from "@twiage/core";

import type { GeneralStoreState } from "../types/GeneralStoreState";
import type { ToggleableGlobalOptions } from "../types/ToggleableGlobalOptions";

const defaultToggleableGlobalOptions: ToggleableGlobalOptions = {
  useFluidLayout: false,
  useModals: true,
  useScrollFieldsOnly: true,
};

export const getInitialGeneralStoreState = (): GeneralStoreState => {
  const toggleableGlobalOptions =
    storageService.getItemAsObject<ToggleableGlobalOptions>(
      "toggleableGlobalOptions",
    ) ?? defaultToggleableGlobalOptions;

  Object.keys(defaultToggleableGlobalOptions).forEach((key: string) => {
    if (
      toggleableGlobalOptions[key as keyof ToggleableGlobalOptions] ===
      undefined
    ) {
      toggleableGlobalOptions[key as keyof ToggleableGlobalOptions] =
        defaultToggleableGlobalOptions[key as keyof ToggleableGlobalOptions];
    }
  });

  storageService.save("toggleableGlobalOptions", toggleableGlobalOptions);

  return {
    toggleableGlobalOptions,
  };
};
